/* global google, GMaps */

import helpers from '../util/helpers';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    const standaloneHeader = $('.standalone-header');
    if (standaloneHeader.length) {
      helpers.onWindowEvents(() => {
        if ($(window).scrollTop() > standaloneHeader.outerHeight()) {
          standaloneHeader.addClass('scrolled');
        } else {
          standaloneHeader.removeClass('scrolled');
        }
      }, 1, 1, 0, 1);
    }

    const standaloneWeddingVenue = $('.standalone-wedding-venues');
    if (standaloneWeddingVenue.length) {
      const slider = standaloneWeddingVenue.find('.standalone-slider');
      const nextArrow = standaloneWeddingVenue.find('.next-arrow');
      const prevArrow = standaloneWeddingVenue.find('.prev-arrow');

      slider.slick({
        infinite: false,
        slidesToShow: 1,
        nextArrow: nextArrow,
        prevArrow: prevArrow,
        arrows: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      });
    }

    const standaloneWeddingForm = $('.standalone-wedding-form');
    if (standaloneWeddingForm.length) {
      const formWrapper = standaloneWeddingForm.find('.form-wrapper');
      if (formWrapper.length) {
        const pdfFile = formWrapper.data('pdf-file');
        if (pdfFile) {
          $(document).on('wpcf7mailsent', function() {
            window.open(pdfFile, '_blank');
          });
        }
      }
    }

    const standaloneWeddingMap = $('.standalone-wedding-map');
    if (standaloneWeddingMap.length) {
      const mapDiv = standaloneWeddingMap.find('#map');
      if (mapDiv.length) {
        const title = mapDiv.data('title');
        const address = mapDiv.data('address');
        const locationLat = mapDiv.data('lat');
        const locationLng = mapDiv.data('lng');
        const markerUrl = mapDiv.data('marker-url');
        const infoWindowTemplate = standaloneWeddingMap.find('#map-marker-info-window').html();

        const transformMapInfo = function(data, template) {
          const keys = [];
          const values = [];

          $.each(data, function (key, value) {
            keys.push(key);
            values.push(value);
          });

          for (let i = 0; i < keys.length; i++) {
            template = template.replace(new RegExp('--' + keys[i] + '--', 'g'), values[i]);
          }

          return template;
        };

        const map = new GMaps({
          div: '#map',
          scrollwheel: false,
          lat: locationLat,
          lng: locationLng,
          zoom: 10,
        });

        map.addMarker({
          lat: locationLat,
          lng: locationLng,
          title: title,
          icon: {
            scaledSize: new google.maps.Size(26, 26),
            url: markerUrl,
          },
          infoWindow: {
            'content': transformMapInfo({
              name: title,
              address: address,
            }, infoWindowTemplate),
          },
          click() {
            setTimeout(() => {
              // Remove info window arrow
              const gmStyleIw = $('.gm-style-iw');
              const gmArrow = gmStyleIw.prev().find('div').eq(2);
              gmArrow.parent().find('div').eq(0).hide();
              gmArrow.hide();
            }, 10);
          },
        });
      }
    }

    const scrollToForm = $('.to-standalone-form');
    if (scrollToForm.length) {
      scrollToForm.on('click', function(e) {
        e.preventDefault();

        $('.standalone-wedding-form').goToElement(undefined, -73);
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateHotelVenueWeddingsConversion.js